import axios from 'axios';
import { logout } from './userActions';

export const getChartDataInitials = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(`/api/chart-dashboard`, config);
    // const data = {
    //   destinationCountries: [],
    //   sourceCountries: [],
    //   destinationIPs: [
    //     ['US', '100'],
    //     ['India', '240'],
    //     ['India', '200'],
    //     ['India', '450'],
    //   ],
    //   destinationPorts: [],
    //   status: true,
    // };

    if (data && data.status) {
      return data;
    } else if (data && !data.status) {
      dispatch(logout());
    } else {
      return {};
    }
  } catch (err) {
    return {};
    // return err.response && err.response.data ? err.response.data : err.message;
  }
};

export const getChartData = (formData) => async (dispatch) => {
  try {
    console.log('Sending request to /api/chart-dashboard');
    // Don't override Content-Type, let axios set it correctly for FormData
    const { data } = await axios.post(`/api/chart-dashboard`, formData);
    console.log('Received response:', data);

    // const data = {
    //   destinationCountries: [
    //     ['US', '100'],
    //     ['India', '240'],
    //     ['India', '240'],
    //     ['India', '240'],
    //   ],
    //   sourceCountries: [
    //     ['US', '100'],
    //     ['India', '240'],
    //     ['India', '240'],
    //     ['India', '240'],
    //   ],
    //   destinationIPs: [
    //     ['US', '100'],
    //     ['India', '240'],
    //     ['India', '200'],
    //     ['India', '450'],
    //   ],
    //   destinationPorts: [],
    //   status: true,
    // };
    // console.log('called');

    if (data && data.status) {
      return data;
    } else if (data && !data.status) {
      console.log('Not logged in:', data.msg);
      dispatch(logout());
    } else {
      console.log('Empty data received');
      return {};
    }
  } catch (err) {
    console.error('Error fetching chart data:', err);
    return {};
    // return err.response && err.response.data ? err.response.data : err.message;
  }
};
